<script lang="ts">
	import {word} from './stores';
	import {get} from 'svelte/store'
	let tysCredit = {
		year: "2009",
		paper: "2",
		qn: "8"
	}
	import Button, {Label} from '@smui/button';
	import random from './check_random/random'
	function randomize(){
		let newWord = get(word);
		while (newWord==get(word)){
			newWord = random()
		}
		word.set(newWord);
	}
</script>

<p>
	This question is generated by the word {$word}. <br> On your next visit you can use this word to return to this specific question under the options tab.
</p> 
<hr>
<Button on:click={randomize} variant="unelevated" class="button-shaped-round">
	<Label>Randomize Question</Label>
</Button> 
<hr>
{#if tysCredit.year}
<p> Part (a) of this question is inspired by the {tysCredit.year} A Levels H2 Mathematics Paper {tysCredit.paper} Question {tysCredit.qn}</p>
{/if}
